/**
 * Shared kernel, the result shape every form-handling server action returns
 * to useActionState. Screens render fieldErrors inline and formError as a
 * banner (docs/ux/templates/screen.md, States).
 */
export interface FormState {
  /** Banner-level error, safe to display. */
  formError?: string;
  /** Inline errors keyed by field name; copy comes from the screen docs. */
  fieldErrors?: Record<string, string>;
  /** Submitted values echoed back so input is preserved on failure. */
  values?: Record<string, string>;
  /**
   * Set on success when the screen reacts to it (clear the form, show a
   * success banner, docs/ux/screens/*.md States). Short token or message.
   */
  success?: string;
}

export const SYSTEM_ERROR =
  "Something went wrong on our side. Please try again.";
